import React from 'react';

import { Modal } from 'src/components/common';
import { InviteEmployersAdminsByPeoStaffModalContent } from 'src/components/employer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const InviteEmployersAdminsByPeoStaffModal: React.FC = () => {
  const { closeModal, switchClosability, isOpen } = useModal(
    ModalId.InviteEmployersAdminsByPeoStaff,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  return (
    <Modal
      title="Add Employers"
      headerPadding="32px 32px 8px 32px"
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <InviteEmployersAdminsByPeoStaffModalContent
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
